import { InputHTMLAttributes, ReactNode } from 'react';

export type FormInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> & {
  label?: string;
  helpText?: ReactNode;
  isFilled?: boolean;
  error?: boolean;
  customStyles?: {
    container?: React.CSSProperties;
    label?: React.CSSProperties;
    input?: React.CSSProperties;
    helpText?: React.CSSProperties;
  };
};

const FormInput = ({
  label,
  helpText,
  isFilled,
  error = false,
  customStyles = {},
  id,
  className = '',
  disabled,
  value,
  ...props
}: FormInputProps) => {
  const inputId = id || label;
  const filled = isFilled || (value !== undefined && value !== '');
  const labelClass = error
    ? 'text-[var(--negative-200,#7F1D1D)]'
    : disabled
      ? 'text-neutral-200'
      : 'text-[var(--primary-300,#115873)]';
  const inputClass = error
    ? 'border-[var(--negative-200,#7f1d1d)] text-[var(--negative-200,#7F1D1D)] focus:border-[var(--negative-100,#EF4444)]'
    : filled
      ? 'border-neutral-200 text-neutral-400 focus:border-[var(--neutral-400,#177ba6)]'
      : 'border-neutral-200 text-neutral-200 focus:border-[var(--neutral-400,#177ba6)]';

  return (
    <div className="flex w-full flex-col items-start gap-2" style={customStyles.container}>
      {label && (
        <label htmlFor={inputId} style={customStyles.label} className={labelClass}>
          {label}
        </label>
      )}
      <input
        {...props}
        id={inputId}
        value={value}
        disabled={disabled}
        data-testid="input"
        style={customStyles.input}
        className={`w-full rounded-md border bg-white px-3 py-2 text-base shadow-sm outline-none disabled:bg-neutral-50 disabled:text-neutral-200 ${inputClass} ${className}`}
      />
      {helpText && (
        <span
          style={customStyles.helpText}
          className={`text-xs ${error ? 'text-[var(--negative-200,#7F1D1D)]' : 'text-neutral-200'}`}>
          {helpText}
        </span>
      )}
    </div>
  );
};

export default FormInput;
